import { Box, Grid, Typography } from "@mui/material";

import AcquisitionBreakdownSection from "../AcquisitionBreakdownSection";
import ExecutiveKpiCard from "../ExecutiveKpiCard";
import ContractorPerformanceTable from "../components/ContractorPerformanceTable";
import ContractorPerformanceCharts from "../components/ContractorPerformanceCharts";
import { pick } from "../managementDashboardUtils";

const ContractorIntelligenceTab = ({
  overview,
  analyticsLoading,
  executiveKpis,
  currencyUnit,
  kpiLoading,
  acquisitionLoading,
  acquisitionError,
  acquisitionData,
  contractorPerfLoading,
  contractorPerfError,
  contractorPerfData,
  dashboardFilters,
  loadAcquisitionBreakdown,
  loadContractorPerformance,
}) => {
  const contractorKpi = executiveKpis.find(
    (k) => pick(k, "code", "Code") === "ActiveContractors"
  );
  const totalContractors = overview?.activeContractors ?? overview?.ActiveContractors;
  const perf = contractorPerfData || {};

  return (
    <Box>
      <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
        شاخص‌های پیمانکار
      </Typography>
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <ExecutiveKpiCard
            kpi={{
              title: "کل پیمانکاران",
              value: pick(perf, "totalContractors", "TotalContractors") ?? totalContractors,
              unit: "پیمانکار",
              isAvailable: true,
              metricType: 2,
              comparisonState: 3,
              ...(contractorKpi || {}),
            }}
            currencyUnit={currencyUnit}
            loading={contractorPerfLoading || kpiLoading || analyticsLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ExecutiveKpiCard
            kpi={{
              title: "پیمانکاران فعال",
              value: pick(perf, "activeContractors", "ActiveContractors"),
              unit: "پیمانکار",
              isAvailable: true,
              metricType: 2,
              comparisonState: 3,
            }}
            currencyUnit={currencyUnit}
            loading={contractorPerfLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ExecutiveKpiCard
            kpi={{
              title: "میانگین تبدیل",
              value: pick(perf, "averageConversionRate", "AverageConversionRate"),
              unit: "%",
              isAvailable: pick(perf, "averageConversionRate", "AverageConversionRate") != null,
              metricType: 2,
              comparisonState: 3,
            }}
            currencyUnit={currencyUnit}
            loading={contractorPerfLoading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ExecutiveKpiCard
            kpi={{
              title: "میانگین زمان اجرا",
              value: pick(perf, "averageExecutionTimeDays", "AverageExecutionTimeDays"),
              unit: "روز",
              isAvailable: pick(perf, "averageExecutionTimeDays", "AverageExecutionTimeDays") != null,
              metricType: 2,
              comparisonState: 3,
            }}
            currencyUnit={currencyUnit}
            loading={contractorPerfLoading}
          />
        </Grid>
      </Grid>

      <ContractorPerformanceTable
        loading={contractorPerfLoading}
        error={contractorPerfError}
        data={contractorPerfData}
        onRetry={() => loadContractorPerformance(dashboardFilters)}
      />

      <ContractorPerformanceCharts
        loading={contractorPerfLoading}
        error={contractorPerfError}
        data={contractorPerfData}
        onRetry={() => loadContractorPerformance(dashboardFilters)}
      />

      <AcquisitionBreakdownSection
        loading={acquisitionLoading}
        error={acquisitionError}
        data={acquisitionData}
        onRetry={() => loadAcquisitionBreakdown(dashboardFilters)}
      />
    </Box>
  );
};

export default ContractorIntelligenceTab;
